const GENDER_KEY_BY_VALUE = {
	'': 'all',
	Male: 'male',
	Female: 'female',
	Unisex: 'unisex',
};

const LEVEL_KEY_BY_VALUE = {
	'': 'all',
	Beginner: 'beginner',
	Intermediate: 'intermediate',
	Advanced: 'advanced',
};

const MUSCLE_GROUP_KEY_BY_VALUE = {
	'': 'all',
	Chest: 'chest',
	Back: 'back',
	Legs: 'legs',
	Shoulders: 'shoulders',
	Arms: 'arms',
	Core: 'core',
	Glutes: 'glutes',
	'Full Body': 'full_body',
};

const GOAL_KEY_BY_VALUE = {
	'': 'all',
	Strength: 'strength',
	'Fat Loss': 'fat_loss',
	Endurance: 'endurance',
	'Muscle Gain': 'muscle_gain',
	Flexibility: 'flexibility',
};

const STATUS_KEY_BY_VALUE = {
	active: 'active',
	Active: 'active',
	completed: 'completed',
	Completed: 'completed',
	paused: 'paused',
	Paused: 'paused',
	cancelled: 'cancelled',
	Cancelled: 'cancelled',
	inactive: 'inactive',
	Inactive: 'inactive',
};

const getTranslatedValue = (t, value, map, baseKey, fallback = value) => {
	const key = map[value];
	return key ? t(`${baseKey}.${key}`) : fallback;
};

export const translateWorkoutGender = (t, value, fallback) =>
	getTranslatedValue(t, value, GENDER_KEY_BY_VALUE, 'workouts.enums.gender', fallback || value);

export const translateWorkoutLevel = (t, value, fallback) =>
	getTranslatedValue(t, value, LEVEL_KEY_BY_VALUE, 'workouts.enums.level', fallback || value);

export const translateWorkoutMuscleGroup = (t, value, fallback) =>
	getTranslatedValue(t, value, MUSCLE_GROUP_KEY_BY_VALUE, 'workouts.enums.muscle_group', fallback || value);

export const translateWorkoutGoal = (t, value, fallback) =>
	getTranslatedValue(t, value, GOAL_KEY_BY_VALUE, 'workouts.enums.goal', fallback || value);

export const translateWorkoutStatus = (t, value, fallback) =>
	getTranslatedValue(t, value, STATUS_KEY_BY_VALUE, 'workouts.enums.status', fallback || value);

export const getWorkoutGenderOptions = (t, includeAllKey = 'workouts.enums.gender.all') => [
	{ label: t(includeAllKey), value: '' },
	{ label: t('workouts.enums.gender.male'), value: 'Male' },
	{ label: t('workouts.enums.gender.female'), value: 'Female' },
	{ label: t('workouts.enums.gender.unisex'), value: 'Unisex' },
];

export const getWorkoutLevelOptions = (t, includeAllKey = 'workouts.enums.level.all') => [
	{ label: t(includeAllKey), value: '' },
	{ label: t('workouts.enums.level.beginner'), value: 'Beginner' },
	{ label: t('workouts.enums.level.intermediate'), value: 'Intermediate' },
	{ label: t('workouts.enums.level.advanced'), value: 'Advanced' },
];

export const getWorkoutMuscleGroupOptions = (t, includeAllKey = 'workouts.enums.muscle_group.all') => [
	{ label: t(includeAllKey), value: '' },
	{ label: t('workouts.enums.muscle_group.chest'), value: 'Chest' },
	{ label: t('workouts.enums.muscle_group.back'), value: 'Back' },
	{ label: t('workouts.enums.muscle_group.legs'), value: 'Legs' },
	{ label: t('workouts.enums.muscle_group.shoulders'), value: 'Shoulders' },
	{ label: t('workouts.enums.muscle_group.arms'), value: 'Arms' },
	{ label: t('workouts.enums.muscle_group.core'), value: 'Core' },
	{ label: t('workouts.enums.muscle_group.glutes'), value: 'Glutes' },
	{ label: t('workouts.enums.muscle_group.full_body'), value: 'Full Body' },
];

export const getWorkoutGoalOptions = (t, includeAllKey = 'workouts.enums.goal.all') => [
	{ label: t(includeAllKey), value: '' },
	{ label: t('workouts.enums.goal.strength'), value: 'Strength' },
	{ label: t('workouts.enums.goal.fat_loss'), value: 'Fat Loss' },
	{ label: t('workouts.enums.goal.endurance'), value: 'Endurance' },
	{ label: t('workouts.enums.goal.muscle_gain'), value: 'Muscle Gain' },
	{ label: t('workouts.enums.goal.flexibility'), value: 'Flexibility' },
];